import * as React from "react";
import CenterDiv from "./CenterDiv";
import CoreDropzone from "./CoreDropzone";
import ProgressBar from "./ProgressBar";
import { uniqueId } from "lodash";
import produce from "immer";
import { toast } from "../../utils";

interface IProps {
  onDrop: (acceptedFiles: File[]) => Promise<void>;
  uploadedFiles: IJsonApiFile[];
  maxFileSize?: number;
}
 
interface IState {
  uploadingFiles: Array<{ name: string; uploadId: string }>;
}

class FileUploader extends React.Component<IProps, IState> {
  state: Readonly<IState> = { uploadingFiles: [] };

  onDrop = async (acceptedFiles: File[]) => {
    const uploadId = uniqueId("upload_");
    // use passed in value or defualt to 50kb 
    const maxFileSize = (this.props.maxFileSize || 50) * 1000000
    const LargestFile = Math.max(...acceptedFiles.map( f => f.size))
    if(LargestFile > maxFileSize){
      toast.error(`Files cannot be larger than ${maxFileSize / 1000000} MB`)
    }
    else{
      this.setState(
        produce<IState>(draft => {
          draft.uploadingFiles = draft.uploadingFiles.concat(
            acceptedFiles.map(f => ({ name: f.name, uploadId }))
          );
        })
      );
  
      await this.props.onDrop(acceptedFiles);
  
      this.setState(
        produce<IState>(draft => {
          draft.uploadingFiles = draft.uploadingFiles.filter(
            f => f.uploadId !== uploadId
          );
        })
      );
    }
  };  
  render() {
    const { uploadedFiles = [] } = this.props;
    const { uploadingFiles } = this.state;

    return (
      <>
        <CenterDiv>
          <CoreDropzone onDrop={this.onDrop}>
            Drop Files Here or Click to Upload
          </CoreDropzone>
        </CenterDiv>
        <CenterDiv>
          {uploadingFiles.length > 0 && (
            <p>
              <strong>Uploading Files...</strong>
            </p>
          )}
          {uploadingFiles.map(f => (
            <ProgressBar
              key={`${f.uploadId}_${f.name}`}
              active={true}
              progress={100}
              striped={true}
            >
              {f.name}
            </ProgressBar>
          ))}
        </CenterDiv>
        <hr />
        <CenterDiv>
          <p>
            <strong>Uploaded Files</strong>
          </p>
        </CenterDiv>
        <CenterDiv>
          {uploadedFiles.length > 0 ? (
            uploadedFiles.map(f => (
              <div key={f.url}>
                <a target={"_blank"} rel="noopener noreferrer" href={f.url}>
                  {f.name}
                </a>
              </div>
            ))
          ) : (
            <p>Nothing yet.</p>
          )}
        </CenterDiv>
      </>
    );
  }
}

export default FileUploader;



// WEBPACK FOOTER //
// ./app/javascript/components/core/FileUploader.tsx